import React from 'react';
import PropTypes from 'prop-types';

import Box, { BoxProps as BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Icons } from '@classity-edtech/ui-base';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';

export interface EnrolmentNavProps extends BoxProps {
  goBack?: () => void;
  close: () => void;
}

export const EnrolmentNav = ({
  className,
  children,
  goBack,
  close,
  ...props
}: EnrolmentNavProps) => {
  return (
    <>
      <Box
        className={className}
        sx={theme => ({
          display: 'flex',
          position: 'sticky',
          top: 0,
          background: theme.palette.background.paper,
          alignItems: 'center',
          justifyContent: 'space-between',
          py: { xs: 1, md: 2 },
          borderBottom: `solid 1px ${globalColours['$global-colour-interactive-secondary-default']}`,
        })}
        {...props}
      >
        {typeof goBack === 'function' && (
          <Icons.ArrowRightIcon
            data-testid='navigation-back'
            sx={{ cursor: 'pointer', mr: 'auto', transform: 'rotate(180deg)' }}
            onClick={goBack}
          />
        )}
        <Box
          sx={{
            cursor: 'pointer',
            ml: 'auto',
            p: { xs: 1, md: 1.5 },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            aspectRatio: '1 / 1',
            borderRadius: '100%',
            background: globalColours['$global-colour-background-neutral-default'],
          }}
          data-testid='navigation-close'
          onClick={close}
        >
          <Icons.Cancel sx={{ fontSize: { xs: '16px', md: '24px' } }} />
        </Box>
      </Box>
    </>
  );
};

EnrolmentNav.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

EnrolmentNav.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(EnrolmentNav)(
  ({ theme }) => `
  &.MuiBox-root {
  }
`,
);
